import { render, staticRenderFns } from "./BiometricEquipment.vue?vue&type=template&id=2e9a3038&scoped=true"
import script from "./BiometricEquipment.vue?vue&type=script&lang=js"
export * from "./BiometricEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a3038",
  null
  
)

export default component.exports